// these are only uids which route within the applications for the care apps - help-home and account-billing
export const ApplicationRoutedUids = [
  'my-payment-didnt-go-through',
  'understanding-your-bills',
  'first-bill-explainer',
  'current-bill-explainer',
  'my-final-bill-explainer',
];

// these are the deploy urls for care apps
export const CareApplications = {
  'help-home': '/support/help/',
  'account-billing': '/support/help/billing-and-payment/',
  'service-status': '/support/help/service-status/',
  'tv-streaming-help': '/support/help/tv/streaming/',
  'change-package': '/support/help/change-my-package/',
};

export const CompaxExplicitRirectUrlMapping = [
  {
    uid: 'tv-error-code',
    url: '/tv-error-code/which-error-code',
  },
  {
    uid: 'tv-fault',
    url: '/tv-fault/tv-check-services',
  },
  {
    uid: 'tv-picture-issues',
    url: '/tv-picture-issues/which-tv-box',
  },
  {
    uid: 'tv-sound-issues',
    url: '/tv-sound-issues/which-tv-box',
  },
];

export const CareApplicationSpecificUidMapping = [
  {
    uid: 'view-your-bill-1',
    appUrl: CareApplications['help-home'],
    path: 'view-your-bill-1',
  },
  {
    uid: 'first-bill-explainer',
    appUrl: CareApplications['account-billing'],
    path: 'bill-explainer/first-bill-explainer',
  },
  {
    uid: 'current-bill-explainer',
    appUrl: CareApplications['account-billing'],
    path: 'bill-explainer/current-bill-explainer',
  },
  {
    uid: 'my-final-bill-explainer',
    appUrl: CareApplications['account-billing'],
    path: 'bill-explainer/my-final-bill-explainer',
  },
  {
    uid: 'my-payment-didnt-go-through',
    appUrl: CareApplications['account-billing'],
    path: 'my-payment-didnt-go-through',
  },
  {
    uid: 'make-a-payment-logged-out',
    appUrl: CareApplications['account-billing'],
    path: 'my-virgin-media/collections/pay-now',
  },
  {
    uid: 'struggling-to-pay-3',
    appUrl: CareApplications['account-billing'],
    path: 'my-virgin-media/collections/struggling-to-pay',
  },
  {
    uid: 'broadband-tv-and-landline-4',
    appUrl: CareApplications['account-billing'],
    path: 'my-virgin-media/billing',
  },
  {
    uid: 'change-package-1',
    appUrl: CareApplications['change-package'],
    path: '',
  },
  {
    uid: 'change-package-landline',
    appUrl: CareApplications['help-home'],
    path: 'change-package-1',
  },
  {
    uid: 'change-package-2',
    appUrl: CareApplications['help-home'],
    path: 'change-package-1',
  },
  {
    uid: 'change-package-broadband',
    appUrl: CareApplications['help-home'],
    path: 'change-package-1',
  },
  {
    uid: 'restart-my-services',
    appUrl: CareApplications['account-billing'],
    path: 'my-virgin-media/collections/pay-now',
  },
  {
    uid: 'mobile-billing',
    appUrl: CareApplications['account-billing'],
    path: 'view-bill',
  },
];

export const CareApplicationSpecificUidMappingLogout = [
  {
    uid: 'make-a-payment-logged-out',
    appUrl: CareApplications['account-billing'],
    path: 'my-virgin-media/collections/make-a-payment',
  },
];

export const CareApplicationBasedUids = new Map([
  ['change-package-tile', 'change-package-1'],
  ['view-bill-broadband-tile', 'broadband-tv-and-landline-4'],
  ['struggling-to-pay', 'struggling-to-pay-3'],
  ['make-a-payment', 'make-a-payment-logged-out'],
]);

export const DeepLinkRedirectTilesUid = [
  'slow-or-no-broadband',
  'service-status',
  'my-delivery-or-appointment',
  'manage-your-wi-fi-settings',
  'joining-wi-fi-hotspots-1',
  'how-to-connect-to-london-underground',
  'view-your-bill-1',
  'make-a-payment-logged-out',
  'mobile-billing',
  'upgrading',
  'view-my-bill',
  'manage-my-spending-limits',
  'view-recent-usage',
  'understanding-my-plan',
  'changing-my-plan',
  'understanding-data',
  'call-barring',
  'before-you-travel',
  'parental-control',
  'mobile-1',
  'my-virgin-media-1',
  'the-virgin-mobile-app',
];

export const ExternalBrowserTileUids = [
  'my-broadband-speed',
  'my-broadband-usage',
  'my-virgin-media-app',
  'virgin-tv-go-app',
  'virgin-tv-control-app',
  'virgin-media-connect-app',
  'virgin-media-store-app',
  'home-pass',
  'home-works',
  'manage-your-web-safe-settings',
  'faqs-1',
  'fixing-a-problem',
  'join-virgin-media-internet-security',
  'google-one',
  'virgin-media-internet-security-faqs',
  'gadget-rescue',
  'virgin-media-mail',
  'setting-up-guest-network',
  'recycle',
  'marketing-preferences',
  'direct-debit',
  'name-or-address',
  'reset-my-username-or-password',
  'payment-method',
  'forgot-your-username',
  'set-up-secondary-account-holder',
  'bereavement-or-sickness-support',
  'end-of-contract',
  'legal-1',
  'set-up-email',
  'reset-my-password',
  'set-up-email-on-my-device',
  'opt-out',
  'internet-security',
  'refer-a-friend',
  'first-bill-explainer',
  'current-bill-explainer',
  'my-final-bill-explainer',
  'restart-my-services-2',
  'struggling-to-pay-3',
  'automatic-compensation-scheme',
  'e-billing-1',
  'my-payment-didnt-go-through',
  'forgot-log-in-details',
  'my-online-account-faqs',
  'view-and-create-an-online-account',
  'manage-and-change-my-details',
  'switch-or-keep-my-number',
  'get-a-new-or-additional-tariff',
  'my-contract',
  'thinking-of-leaving',
  'account-holder-is-terminally-ill',
  'account-holder-has-passed-away',
  'forgot-your-sign-in-details',
  'bill-explainer-1',
  'my-final-bill-1',
  'my-first-mobile-bill-explained',
  'delivery-or-appointment',
  'cant-receive-calls',
  'issues-in-your-area-1',
  'find-the-last-caller-details',
  'broadband-tv-and-landline',
  'tv-sound-issues',
  'service-status-missing-channels',
  'tv-fault',
  'virgin-tv-lost-or-damaged-tv-remote',
  'virgin-tv-on-demand-not-working',
  'contactus',
  'tv-picture-issues',
  'issues-in-your-area',
  'tv-remote-control-not-working',
  'tv-remote-control-lost',
  'tv-remote-control-damaged',
  'my-delivery-or-appointment-1',
  'tv-error-code',
  'mobile-billing',
  'struggling-to-pay-3',
  'restart-my-services-2',
  'e-billing-1',
  'my-payment-didnt-go-through',
  'tv-moving-home',
  'tv-features',
  'managing-my-direct-debit',
  'pay-as-you-go-top-up',
  'difficulty-making-payments',
  'how-to-make-online-payments',
  'billing-faqs',
  'understanding-my-billing-plan',
  'how-add-more-data',
  'roaming-charges',
  'order-a-new-sim',
  '3g-or-4g-not-working',
  'switch-or-keep-number',
  'acitivate-sim-card',
  'sim-unlock-code',
  'puk-unlock-code',
  'roaming-costs',
  'help-with-roaming',
  'voicemail',
  'device-troubleshooting',
  'mobile-insurance-1',
  'activate-sim-card-1',
  'unlocking-virgin-media-devices',
  'damaged-phone',
  'lost-or-stolen-phone',
  'puk-unlock-code-1',
  'sim-unlock-code-1',
  'coverage-checker',
  'phone-moving-home',
  'malware-alert',
  //deeplinks
  'slow-or-no-broadband',
  'service-status',
  'my-delivery-or-appointment',
  'manage-your-wi-fi-settings',
  'view-your-bill-1',
  'make-a-payment-logged-out',
  'mobile-billing',
  'upgrading',
  'view-my-bill',
  'manage-my-spending-limits',
  'view-recent-usage',
  'understanding-my-plan',
  'changing-my-plan',
  'before-you-travel',
  'parental-control',
  'mobile-1',
  'my-virgin-media-1',
  'the-virgin-mobile-app',
];
